import { Box, Grid, Paper } from "@mui/material";
import Breadcrumb from "../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../App/Components/PageTitle/PageTitle";
import { RandomTextSkeleton } from "../App/Components/Skeleton/RandomTextSkeleton";

export default function FormProfileLoading() {
  return (
    <PageContainer>
      <Breadcrumb pageTitle="Loading..." />
      <Paper sx={{ mt: { xs: 1, md: 4 }, p: { xs: 2, lg: 4 } }}>
        <Grid container sx={{ width: 1 }}>
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: "flex",
              alignItems: "center",
              pr: { xs: 0, md: 2 },
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 0,
                flexGrow: 1,
                flexFlow: "row wrap",
                alignItems: "center",
                position: "relative",
              }}
            >
              <PageTitle
                sx={{
                  width: 1,
                  lineHeight: 1,
                  color: "secondary.main",
                }}
              >
                <RandomTextSkeleton />
              </PageTitle>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </PageContainer>
  );
}
